import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const allProductApprovalList = payload => AxiosClient.get('/all-product-approval-list', payload);
const allFilterApprovalList = payload => AxiosClient.post('/filter-approval-record', payload);
const productWiseApprovalList = item_no => AxiosClient.get(`/product-wise-approval-list/${item_no}`);
const approveEachProduct = payload => AxiosClient.post('/modify-product-quantity', payload);
const pendingApprovalList = payload =>  AxiosClient.get('/pending-approval-list', payload);
const approveRequisitionItem = payload => AxiosClient.post('/approve-pending-approval', payload);
const createProcurementRelation = payload =>AxiosClient.post('/create-requisition-relation', payload);
const saveModifiedQty = payload =>AxiosClient.post('/save-modified-qty', payload);
const fetchProductListForVendorAllocation = payload =>  AxiosClient.post('/fetch-product-distribution-list', payload);
const fetchFilterListForAllocation = payload =>  AxiosClient.post('/get-filter-list-to-assign', payload)
const fetchPaymentOptions = () =>  AxiosClient.get('/get-payment-options')

const saveDistributedQuantity = payload => AxiosClient.post('/product-distribution-vendorwise', payload);
// const fetchAllVendorList = payload => AxiosClient.post('/fetch-vendor-lists', payload);
const fetchProductListForGeneratePO = payload =>  AxiosClient.post('/fetch-product-distribution-list', payload);
const saveAdjustedValue = payload => AxiosClient.post('/update-adjusted-value', payload);
const generatePO = payload => AxiosClient.post('/generate-PO', payload);
const updatePODetails = payload => AxiosClient.post('/update-PO-details', payload);
const updatePaymentAndActualDate = payload => AxiosClient.post('/update-payment-actual-date', payload);
const sendPoForManagementApproval =payload => AxiosClient.post('/PO-management-approval', payload);

const fetchProductListForUserArrivalDateUpdate = () =>  AxiosClient.get('/system-po-list?category=DateUpdate');
const fetchUserDateUpdate = () =>  AxiosClient.get('/user-date-update-list');


const updateUserArrivalDate = payload => AxiosClient.post('/update-user-arrival-date', payload);



export {
    allProductApprovalList,
    allFilterApprovalList,
    productWiseApprovalList,
    approveEachProduct,
    pendingApprovalList,
    approveRequisitionItem,
    createProcurementRelation,
    saveModifiedQty,
    fetchProductListForVendorAllocation,
    fetchFilterListForAllocation,
    saveDistributedQuantity,
    // fetchAllVendorList,
    fetchUserDateUpdate,
    fetchProductListForGeneratePO,
    saveAdjustedValue,
    generatePO,
    updatePaymentAndActualDate,
    fetchPaymentOptions,
    fetchProductListForUserArrivalDateUpdate,
    updateUserArrivalDate,
    sendPoForManagementApproval,
    updatePODetails,
}